import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class MoodleCourseCompletionSnapshotsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      loaded: 0,
      dados: [],
      loadError: '',
      exporting: false,
      modal: false,
      modalLoading: false,
      modalError: '',
      modalData: null,
    };

    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.loadData = this.loadData.bind(this);
    this.exportExcel = this.exportExcel.bind(this);
    this.openResponse = this.openResponse.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.formatStaff = this.formatStaff.bind(this);
    this.formatTeam = this.formatTeam.bind(this);
    this.formatStatus = this.formatStatus.bind(this);
    this.formatActions = this.formatActions.bind(this);
  }

  componentDidMount() {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({ loaded: 2 }, this.loadData);
    }
  }

  handleAlert(message, type, status, mode) {
    if (mode === 'reset') {
      this.setState({ overlay: { message: '', type: '', status: 'closed' } });
    } else {
      this.setState({ overlay: { message: message, type: type, status: status } });
    }
  }

  handleLoaded(state) {
    if (this.state.loaded !== 2) {
      this.setState({ loaded: state });
    }
  }

  loadData() {
    var headers = this.refs.request_api.header('application/json');
    var self = this;

    this.setState({ loadError: '', overlay: { message: '', type: '', status: 'open' } });
    fetch(config.get('api') + '/moodle/conclusoes-pendentes', {
      method: 'GET',
      mode: 'cors',
      headers: headers,
    })
      .then(response => response.json())
      .then(responseJson => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson && responseJson.status === 'success') {
          self.setState({ dados: responseJson.data || [] });
          return;
        }

        var denied = responseJson && responseJson.permission_denied;
        self.setState({
          dados: [],
          loadError: denied
            ? 'Seu usuário não tem permissão para acessar este acompanhamento.'
            : ((responseJson && responseJson.message) || 'Não foi possível carregar o acompanhamento.'),
        });
      })
      .catch(error => {
        console.error(error);
        self.setState({
          dados: [],
          loadError: 'Não foi possível carregar o acompanhamento. Tente novamente.',
        });
      })
      .then(() => {
        self.setState({ overlay: { message: '', type: '', status: 'closed' } });
      });
  }

  openResponse(row) {
    var headers = this.refs.request_api.header('application/json');
    var self = this;

    this.setState({
      modal: true,
      modalLoading: true,
      modalError: '',
      modalData: null,
    });

    fetch(config.get('api') + '/moodle/conclusoes-pendentes/' + row.id, {
      method: 'GET',
      mode: 'cors',
      headers: headers,
    })
      .then(response => response.json())
      .then(responseJson => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson && responseJson.status === 'success') {
          self.setState({ modalData: responseJson.data, modalLoading: false });
          return;
        }

        self.setState({
          modalLoading: false,
          modalError: (responseJson && responseJson.message) || 'Não foi possível carregar o retorno do Moodle.',
        });
      })
      .catch(error => {
        console.error(error);
        self.setState({
          modalLoading: false,
          modalError: 'Não foi possível carregar o retorno do Moodle. Tente novamente.',
        });
      });
  }

  closeModal() {
    this.setState({
      modal: false,
      modalLoading: false,
      modalError: '',
      modalData: null,
    });
  }

  exportExcel(event) {
    event.preventDefault();
    var headers = this.refs.request_api.header();
    var self = this;

    this.setState({ exporting: true });
    fetch(config.get('api') + '/moodle/conclusoes-pendentes/exportar', {
      method: 'GET',
      mode: 'cors',
      headers: headers,
    })
      .then(response => {
        if (!response.ok) {
          return response.json().then(responseJson => {
            self.refs.request_api.validate(responseJson, 'alert');
            throw new Error((responseJson && responseJson.message) || 'Não foi possível exportar a planilha.');
          });
        }

        var disposition = response.headers.get('Content-Disposition') || '';
        var match = disposition.match(/filename\*?=(?:UTF-8''|["'])?([^"';]+)/i);
        var fileName = match && match[1]
          ? decodeURIComponent(match[1].replace(/["']/g, ''))
          : 'acompanhamento-conclusao-moodle.xlsx';

        return response.blob().then(blob => {
          var url = window.URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        });
      })
      .then(() => {
        self.setState({ exporting: false });
      })
      .catch(error => {
        console.error(error);
        self.setState({ exporting: false });
        self.handleAlert(error.message || 'Não foi possível exportar a planilha.', 'error', 'open');
      });
  }

  formatStaff(cell, row) {
    return row.staff_id ? <Link to={'/aluno/editar/' + row.staff_id}>{cell || '-'}</Link> : (cell || '-');
  }

  formatTeam(cell, row) {
    return row.team_id ? <Link to={'/turma/editar/' + row.team_id}>{cell || '-'}</Link> : (cell || '-');
  }

  formatStatus() {
    return <span className="label label-warning">completed = false</span>;
  }

  formatActions(cell, row) {
    return (
      <button className="btn btn-info btn-xs" type="button" onClick={() => { this.openResponse(row); }}>
        <i className="fa fa-fw fa-code"></i> Ver retorno
      </button>
    );
  }

  renderModalBody() {
    if (this.state.modalLoading) {
      return <div className="text-center moodle-completion-modal-state"><i className="fa fa-fw fa-spinner fa-spin"></i> Carregando retorno...</div>;
    }

    if (this.state.modalError) {
      return <div className="alert alert-danger">{this.state.modalError}</div>;
    }

    if (!this.state.modalData) {
      return null;
    }

    var data = this.state.modalData;
    return (
      <div>
        <div className="row moodle-completion-context">
          <div className="col-sm-4"><strong>Última consulta:</strong><br />{data.observed_at_str}</div>
          <div className="col-sm-4"><strong>Aluno:</strong><br />{data.staff_name || '-'} (ID {data.staff_id})</div>
          <div className="col-sm-4"><strong>Turma:</strong><br />{data.team_name || '-'}</div>
        </div>
        <pre className="moodle-completion-json">{JSON.stringify(data.response, null, 2)}</pre>
      </div>
    );
  }

  render() {
    return (
      <div className="moodle-completion-snapshots-page">
        <Topo></Topo>
        <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />

        <div className="container-fluid">
          <div className="conteudo">
            <div className="moodle-completion-heading">
              <h3 className="page-title">Acompanhamento de conclusão no Moodle</h3>
              <button
                type="button"
                className="btn btn-success"
                disabled={this.state.exporting}
                onClick={this.exportExcel}
              >
                <i className={'fa fa-fw ' + (this.state.exporting ? 'fa-spinner fa-spin' : 'fa-file-excel-o')}></i>
                {this.state.exporting ? ' Exportando...' : ' Exportar Excel'}
              </button>
            </div>
            <hr />

            <div className="alert alert-info moodle-completion-notice">
              <i className="fa fa-fw fa-info-circle"></i>
              Cada linha representa o retorno mais recente <strong>completed = false</strong> informado pelo Moodle para o aluno e curso. A data/hora é renovada a cada consulta; quando o Moodle informar <strong>completed = true</strong>, a linha sairá deste painel. Esse estado não significa, necessariamente, uma falha de integração.
            </div>

            {this.state.loadError
              ? <div className="alert alert-danger moodle-completion-error"><i className="fa fa-fw fa-exclamation-circle"></i> {this.state.loadError}</div>
              : null}

            <div className="moodle-completion-table">
              <BootstrapTable
                data={this.state.dados}
                pagination={true}
                striped={true}
                hover={true}
                options={{
                  sizePerPage: 25,
                  sizePerPageList: [25, 50, 100],
                  noDataText: this.state.loadError ? 'Não foi possível exibir os registros' : 'Nenhum retorno atual completed = false registrado',
                  defaultSortName: 'observed_at',
                  defaultSortOrder: 'desc',
                }}
                search={true}
                multiColumnSearch={true}
                searchPlaceholder="Procurar"
              >
                <TableHeaderColumn dataField="id" isKey={true} hidden={true}>ID</TableHeaderColumn>
                <TableHeaderColumn dataField="observed_at" hidden={true}>Última consulta bruta</TableHeaderColumn>
                <TableHeaderColumn dataField="observed_at_str" dataSort={true} dataAlign="center" filter={{ type: 'TextFilter', delay: 200, placeholder: 'Filtrar' }} width="145">Última consulta</TableHeaderColumn>
                <TableHeaderColumn dataField="staff_name" dataFormat={this.formatStaff} dataSort={true} filter={{ type: 'TextFilter', delay: 200, placeholder: 'Filtrar' }} width="210">Aluno</TableHeaderColumn>
                <TableHeaderColumn dataField="team_name" dataFormat={this.formatTeam} dataSort={true} filter={{ type: 'TextFilter', delay: 200, placeholder: 'Filtrar' }} width="180">Turma</TableHeaderColumn>
                <TableHeaderColumn dataField="training_name" dataSort={true} filter={{ type: 'TextFilter', delay: 200, placeholder: 'Filtrar' }} width="190">Treinamento</TableHeaderColumn>
                <TableHeaderColumn dataField="matter_name" dataSort={true} filter={{ type: 'TextFilter', delay: 200, placeholder: 'Filtrar' }} width="190">Matéria</TableHeaderColumn>
                <TableHeaderColumn dataField="moodle_user_id" dataSort={true} dataAlign="center" filter={{ type: 'TextFilter', delay: 200, placeholder: 'Filtrar' }} width="115">Usuário Moodle</TableHeaderColumn>
                <TableHeaderColumn dataField="moodle_course_id" dataSort={true} dataAlign="center" filter={{ type: 'TextFilter', delay: 200, placeholder: 'Filtrar' }} width="105">Curso Moodle</TableHeaderColumn>
                <TableHeaderColumn dataField="completed_label" dataFormat={this.formatStatus} dataAlign="center" width="145">Status</TableHeaderColumn>
                <TableHeaderColumn dataField="actions" dataFormat={this.formatActions} dataAlign="center" width="125">Ação</TableHeaderColumn>
              </BootstrapTable>
            </div>
          </div>
        </div>

        <Modal show={this.state.modal} onHide={this.closeModal} aria-labelledby="moodle-completion-modal-title" bsSize={'large'}>
          <Modal.Header>
            <h4 id="moodle-completion-modal-title" className="pull-left">Retorno de conclusão informado pelo Moodle</h4>
            <button className="btn btn-danger btn-sm pull-right" type="button" aria-label="Fechar" onClick={this.closeModal}>
              <i className="fa fa-fw fa-close"></i>
            </button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>{this.renderModalBody()}</Modal.Body>
          <Modal.Footer>
            <button className="btn btn-default" type="button" onClick={this.closeModal}>Fechar</button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default MoodleCourseCompletionSnapshotsIndex;



// WEBPACK FOOTER //
// ./src/Components/Moodle/MoodleCourseCompletionSnapshotsIndex.js